<template>
  <div class="col-md-8 hos-summary-card-col">
    <div class="hos-summary-card">
      <div class="hos-summary-header">
        <span class="hos-summary-title">{{ statisticsItem[itemKey].data.name }}</span>
      </div>

      <div class="hos-tab-track">
        <button
          v-for="type in tabs"
          :key="type"
          class="hos-tab"
          :class="{ 'hos-tab-active': activeTab === type }"
          @click="changeType(type)"
        >
          {{ type.toUpperCase() }}
        </button>
      </div>

      <HosSummaryTable
        v-if="statisticsItem[itemKey].data[activeTab]"
        :summary="statisticsItem[itemKey].data[activeTab]"
      />
      <div v-else class="hos-summary-empty">
        Please refresh the dashboard to load summary data.
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import HosSummaryTable from "@/components/molecule/company/dashboard/dynamic-dashboard/hospital-table/HosSummaryTable";

const emit = defineEmits(['onTypeChange']);

defineProps({
  statisticsItem: Object,
  itemKey: String,
  page: Object,
});

const changeType = (type) => {
  activeTab.value = type;
  emit('onTypeChange', props.statisticsItem[props.itemKey], type);
}

const tabs = ['billing', 'investigation', 'incentive', 'accounts'];

const activeTab = ref("billing");
</script>

<style scoped>
.hos-summary-card-col {
  padding: 8px;
}

.hos-summary-card {
  background-color: #ffffff;
  border: 1px solid #e8e9ec;
  border-radius: 14px;
  box-shadow: 0 2px 10px rgba(34, 41, 47, 0.06);
  padding: 20px;
}

.hos-summary-header {
  padding-bottom: 14px;
  margin-bottom: 16px;
  border-bottom: 1px solid #f0f1f4;
}

.hos-summary-title {
  font-size: 14px;
  font-weight: 700;
  color: #2b2b2b;
}

.hos-tab-track {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  background-color: #f5f6f8;
  border-radius: 10px;
  padding: 5px;
  margin-bottom: 16px;
}

.hos-tab {
  flex: 1 1 auto;
  border: none;
  background: transparent;
  color: #6e6b7b;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.4px;
  padding: 8px 12px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.hos-tab:hover {
  color: #16a085;
}

.hos-tab-active {
  background-color: #ffffff;
  color: #16a085;
  box-shadow: 0 2px 6px rgba(34, 41, 47, 0.08);
}

.hos-summary-empty {
  text-align: center;
  color: #8a8a8a;
  font-size: 13px;
  padding: 40px 0;
}
</style>
